import { render, staticRenderFns } from "./WPartnerRatingModal.vue?vue&type=template&id=ccd0c758&scoped=true&"
import script from "./WPartnerRatingModal.vue?vue&type=script&lang=js&"
export * from "./WPartnerRatingModal.vue?vue&type=script&lang=js&"
import style0 from "./WPartnerRatingModal.vue?vue&type=style&index=0&id=ccd0c758&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd0c758",
  null
  
)

export default component.exports